export const videos = [
  {
    id: '1',
    title: '流浪地球3：星际远征',
    category: 'movies',
    thumbnail: 'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20with%20spaceship%20and%20galaxy%20background%2C%20dramatic%20lighting%2C%20epic%20atmosphere%2C%20dark%20space%20with%20stars%2C%20warm%20orange%20and%20gold%20accents%2C%20professional%20movie%20poster%20style&width=640&height=360&seq=video-thumb-01&orientation=landscape',
    duration: '2:18:45',
    views: '1280万',
    rating: '9.2',
    date: '2026-07-28',
    description: '在太阳系面临前所未有的危机之际，人类联合政府启动了代号"星际远征"的终极计划。一支由精英宇航员组成的探险队将前往遥远的星系，寻找新的人类家园。',
    tags: ['科幻', '冒险', '国产大片', '吴京', '刘德华'],
  },
  {
    id: '2',
    title: '长安十二时辰之暗影追踪',
    category: 'series',
    thumbnail: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20dynasty%20drama%20scene%20with%20traditional%20architecture%20and%20costumes%2C%20warm%20lantern%20lighting%2C%20mysterious%20atmosphere%2C%20cinematic%20composition%2C%20professional%20film%20still&width=640&height=360&seq=video-thumb-02&orientation=landscape',
    duration: '45:20',
    views: '980万',
    rating: '8.9',
    date: '2026-07-30',
    description: '唐朝天宝年间，长安城中暗流涌动。一位身怀绝技的暗探奉命追查一桩涉及朝廷高层的惊天阴谋，层层谜团背后隐藏的真相令人震惊。',
    tags: ['古装', '悬疑', '历史', '易烊千玺', '雷佳音'],
  },
  {
    id: '3',
    title: '极限挑战第十季：勇者无惧',
    category: 'variety',
    thumbnail: 'https://readdy.ai/api/search-image?query=Outdoor%20adventure%20variety%20show%20scene%20with%20group%20of%20people%20in%20nature%2C%20exciting%20challenge%20atmosphere%2C%20bright%20daylight%2C%20energetic%20vibe%2C%20professional%20TV%20show%20photography&width=640&height=360&seq=video-thumb-03&orientation=landscape',
    duration: '1:32:15',
    views: '1560万',
    rating: '9.5',
    date: '2026-08-01',
    description: '极限挑战第十季重磅回归！全新的挑战任务，更加刺激的户外冒险，明星嘉宾们将在极端环境中突破自我极限，带来欢笑与感动的精彩瞬间。',
    tags: ['综艺', '户外', '挑战', '明星', '搞笑'],
  },
  {
    id: '4',
    title: '深海传奇：蓝色秘境',
    category: 'documentary',
    thumbnail: 'https://readdy.ai/api/search-image?query=Underwater%20documentary%20scene%20with%20colorful%20coral%20reef%20and%20tropical%20fish%2C%20deep%20blue%20ocean%20ambiance%2C%20sunlight%20rays%20through%20water%2C%20professional%20nature%20photography&width=640&height=360&seq=video-thumb-04&orientation=landscape',
    duration: '52:10',
    views: '650万',
    rating: '9.7',
    date: '2026-07-25',
    description: '跟随顶尖海洋生物学家和摄影师团队，深入太平洋最神秘的深海区域，探索前所未见的海洋生物和令人叹为观止的水下奇观。',
    tags: ['纪录', '海洋', '自然', '生物', '探索'],
  },
  {
    id: '5',
    title: '斗破苍穹之帝炎传说',
    category: 'anime',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20style%20fantasy%20battle%20scene%20with%20martial%20arts%20warriors%2C%20flame%20effects%2C%20epic%20composition%2C%20dramatic%20dynamic%20pose%2C%20vibrant%20colors%20warm%20tones&width=640&height=360&seq=video-thumb-05&orientation=landscape',
    duration: '24:35',
    views: '2100万',
    rating: '9.4',
    date: '2026-07-31',
    description: '萧炎历经重重考验，终于触碰到了传说中的帝炎之力。然而更大的挑战正在等待着他——远古八族的宿命之战即将拉开序幕。',
    tags: ['动漫', '玄幻', '热血', '战斗', '国产'],
  },
  {
    id: '6',
    title: '速度与激情11：最终征途',
    category: 'movies',
    thumbnail: 'https://readdy.ai/api/search-image?query=Action%20movie%20scene%20with%20fast%20cars%20racing%20on%20city%20streets%2C%20dramatic%20explosions%2C%20intense%20atmosphere%2C%20warm%20sunset%20lighting%2C%20professional%20cinematography&width=640&height=360&seq=video-thumb-06&orientation=landscape',
    duration: '2:05:30',
    views: '1890万',
    rating: '8.7',
    date: '2026-07-20',
    description: '多姆和他的家人们迎来了最终的征途。这一次，他们将面对一个拥有全球军事力量的超级反派，在五大洲上演惊心动魄的终极对决。',
    tags: ['动作', '赛车', '冒险', '好莱坞', '范迪塞尔'],
  },
  {
    id: '7',
    title: '繁花似锦第二季',
    category: 'series',
    thumbnail: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20drama%20elegant%20urban%20scene%20with%20fashionable%20characters%20in%20city%2C%20warm%20golden%20hour%20lighting%2C%20romantic%20atmosphere%2C%20professional%20TV%20drama%20cinematography&width=640&height=360&seq=video-thumb-07&orientation=landscape',
    duration: '48:15',
    views: '860万',
    rating: '9.0',
    date: '2026-07-29',
    description: '在上海滩的繁华与落寞之间，几个年轻人的命运交织在一起。爱情、友情、梦想在这座不夜城中绽放出最绚丽的光彩。',
    tags: ['都市', '爱情', '励志', '胡歌', '马伊琍'],
  },
  {
    id: '8',
    title: '脱口秀大会第六季',
    category: 'variety',
    thumbnail: 'https://readdy.ai/api/search-image?query=Stand-up%20comedy%20show%20stage%20with%20spotlight%20and%20microphone%2C%20live%20audience%20atmosphere%2C%20warm%20stage%20lighting%2C%20entertaining%20vibe%2C%20professional%20show%20photography&width=640&height=360&seq=video-thumb-08&orientation=landscape',
    duration: '1:18:40',
    views: '1120万',
    rating: '9.1',
    date: '2026-08-01',
    description: '新一季脱口秀大会强势来袭，众多新老脱口秀演员同台竞技，用幽默诙谐的语言解读生活中的酸甜苦辣，笑料不断精彩纷呈。',
    tags: ['综艺', '脱口秀', '喜剧', '搞笑', '语言'],
  },
  {
    id: '9',
    title: '灵笼：终章降临',
    category: 'anime',
    thumbnail: 'https://readdy.ai/api/search-image?query=Dark%20sci-fi%20anime%20style%20post-apocalyptic%20scene%20with%20mecha%20and%20ruins%2C%20dramatic%20moody%20lighting%2C%20atmospheric%20composition%2C%20professional%20animation%20art%20style&width=640&height=360&seq=video-thumb-09&orientation=landscape',
    duration: '30:50',
    views: '1750万',
    rating: '9.6',
    date: '2026-07-27',
    description: '灯塔的真相终于揭晓，马克面临着关乎全人类命运的终极抉择。在末日废墟之上，希望的火种能否重新燃起？',
    tags: ['动漫', '科幻', '末日', '机甲', '国产神作'],
  },
  {
    id: '10',
    title: '舌尖上的中国第五季',
    category: 'documentary',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20scene%20with%20steaming%20hot%20dishes%20on%20table%2C%20traditional%20kitchen%20setting%2C%20warm%20cozy%20lighting%2C%20mouth-watering%20food%20photography%2C%20professional%20cinematography&width=640&height=360&seq=video-thumb-10&orientation=landscape',
    duration: '48:30',
    views: '920万',
    rating: '9.8',
    date: '2026-07-22',
    description: '跨越中国南北大地，探寻最地道的美食文化。从东北的炖菜到岭南的早茶，每一道菜品背后都是一段动人的故事和深厚的文化传承。',
    tags: ['纪录', '美食', '文化', '传统', '中国'],
  },
  {
    id: '11',
    title: '封神第二部：天人之战',
    category: 'movies',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20epic%20film%20scene%20with%20gods%20and%20warriors%20in%20ancient%20battle%2C%20dramatic%20lightning%20and%20clouds%2C%20grand%20cinematic%20scale%2C%20warm%20golden%20and%20crimson%20tones&width=640&height=360&seq=video-thumb-11&orientation=landscape',
    duration: '2:25:10',
    views: '2350万',
    rating: '9.3',
    date: '2026-07-15',
    description: '封神大战进入白热化阶段，姜子牙率领的周朝大军与殷商阵营展开了惊天地泣鬼神的终极对决。天神下凡，凡人逆天，一场改写华夏命运的史诗之战。',
    tags: ['奇幻', '神话', '史诗', '黄渤', '费翔'],
  },
  {
    id: '12',
    title: '向往的生活第九季：田园诗篇',
    category: 'variety',
    thumbnail: 'https://readdy.ai/api/search-image?query=Peaceful%20countryside%20variety%20show%20scene%20with%20wooden%20house%20and%20green%20fields%2C%20warm%20sunset%20light%2C%20relaxing%20atmosphere%2C%20professional%20lifestyle%20photography&width=640&height=360&seq=video-thumb-12&orientation=landscape',
    duration: '1:25:55',
    views: '1380万',
    rating: '9.2',
    date: '2026-07-26',
    description: '在云南大理的苍山洱海之间，明星嘉宾们回归田园生活，自己动手耕种、烹饪、聊天，在慢节奏中寻找生活的真谛和内心的平静。',
    tags: ['综艺', '生活', '田园', '治愈', '慢生活'],
  },
];

export const getVideosByCategory = (categorySlug: string) => {
  if (categorySlug === 'recommended') {
    return [...videos].sort(() => Math.random() - 0.5);
  }
  return videos.filter((v) => v.category === categorySlug);
};

export const getHotVideos = () => {
  return [...videos].sort((a, b) => {
    const aViews = parseInt(a.views.replace('万', ''));
    const bViews = parseInt(b.views.replace('万', ''));
    return bViews - aViews;
  });
};

export const getVideoById = (id: string) => {
  return videos.find((v) => v.id === id);
};